import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  BackendResponse,
  FinalizeSummaryRequest,
  GenerateSummaryRequest,
  GenerateSummaryResponse,
} from '@qtek/shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NoteAiSummaryService {
  private readonly http = inject(HttpClient);

  generateSummary(
    request: GenerateSummaryRequest
  ): Observable<GenerateSummaryResponse> {
    return this.http
      .post<
        BackendResponse<GenerateSummaryResponse>
      >('/api/v2/notes/generate-summary', request, { withCredentials: true })
      .pipe(map(response => response.res as GenerateSummaryResponse));
  }

  finalizeSummary(request: FinalizeSummaryRequest): Observable<string[]> {
    return this.http
      .put<
        BackendResponse<string[]>
      >('/api/v2/notes/finalize-summary', request, { withCredentials: true })
      .pipe(map(response => response.res ?? []));
  }
}
